export default __webpack_public_path__ + "static/media/KW.57a7e47d.svg";